import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "our-process" }
const _hoisted_2 = { class: "grid-x process-guide" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "process-text body-text-rg text-w-bold" }
const _hoisted_5 = { class: "grid-x button-container" }

import { NCard, NButton } from 'naive-ui'
import { projectSubmitIcon, meetingIcon, starIcon, interviewIcon, payrollIcon } from "@/assets/utils/icons";


export default /*#__PURE__*/_defineComponent({
  __name: 'OurProcess',
  setup(__props) {

const steps = [
  {
    icon: projectSubmitIcon,
    text: 'Submit your project and positions requirements.',
  },
  {
    icon: meetingIcon,
    text: 'We’ll meet to go over your needs and resolve any questions.',
  },
  {
    icon: starIcon,
    text: 'Our team will personally vet and select the best candidates that best match your needs.',
  },
  {
    icon: interviewIcon,
    text: 'You’ll pick and interview the candidates you love.',
  },
  {
    icon: payrollIcon,
    text: 'We’ll take care of the offer, payroll, and all needed compliance.',
  },
]


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_unref(NCard), {
      title: "How our process works",
      size: "large",
      style: {"margin-bottom":"60px"},
      embedded: "",
      bordered: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step, i) => {
            return _createElementVNode("div", {
              class: "cell small-12 process-step flex-container",
              key: i
            }, [
              _createElementVNode("div", {
                class: "process-icon",
                innerHTML: step.icon
              }, null, 8, _hoisted_3),
              _createElementVNode("div", _hoisted_4, _toDisplayString(step.text), 1)
            ])
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            class: "width-100",
            to: { name: 'meetings' }
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NButton), {
                focusable: false,
                size: "large"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" BOOK A MEETING ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})